import firebase from "firebase/app";
import Vue from "vue";
import Router from "vue-router";

import PhoneAuth from "@/views/PhoneAuth";
import PatientDownload from "@/views/PatientDownload";
import RegistrationUploadFile from "@/views/RegistrationUploadFile";
import ToViewPatientFiles from "@/views/ToViewPatientFiles";
import optionsView from "@/views/optionsView";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "*",
      redirect: "/error"
    },
    {
      path: "/phone-auth",
      name: "PhoneAuth",
      component: PhoneAuth
    },
    {
      path: "/download-files",
      name: "PatientDownload",
      component: PatientDownload
    },
    ,
    {
      path: "/registration-upload",
      name: "RegistrationUploadFile",
      component: RegistrationUploadFile
    },
    {
      path: "/",
      name: "ToViewPatientFiles",
      component: ToViewPatientFiles
    },
    {
      path: "/act-options",
      name: "optionsView",
      component: optionsView
    }
  ]
});

/*router.beforeEach((to, from, next) => {
  const currentUser = firebase.auth().currentUser;
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  if (requiresAuth && !currentUser) next('login');
  else if (!requiresAuth && currentUser) next('home');
  else next();
});*/

export default router;



// WEBPACK FOOTER //
// ./src/plugins/router/index.js